<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 18:12:54
 * @Description: 用户信息防遗忘
-->
<template>
	<div class="perfect_info">
		<div class="container">
			<div class="title">{{ $t("login.forgotten.title") }}</div>
			<a-form-model :model="form" ref="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
				<a-form-model-item
					:label="$t('base.mobile.label')"
					v-if="basicSetInfo.fywInfoClassify && basicSetInfo.fywInfoClassify.includes('2')"
					prop="sjh"
				>
					<a-input v-model="form.sjh" :placeholder="$t('base.mobile.placeholder')" allowClear></a-input>
				</a-form-model-item>
				<template v-if="basicSetInfo.fywInfoClassify && basicSetInfo.fywInfoClassify.includes('1')">
					<template v-for="(item, index) in form.questionVos">
						<a-form-model-item
							:key="`qus${index}`"
							:label="`${$t('base.question.label')}${index + 1}`"
							:prop="'questionVos.' + index + '.name'"
							:rules="{ required: true, message: $t('base.question.question_placeholder') }"
						>
							<a-input v-model="item.name" disabled></a-input>
						</a-form-model-item>
						<a-form-model-item
							:key="`ans${index}`"
							:label="`${$t('base.question.answer')}${index + 1}`"
							:prop="'questionVos.' + index + '.answer'"
							:rules="{ required: true, message: $t('base.question.placeholder') }"
						>
							<a-input v-model="item.answer" :placeholder="$t('base.question.placeholder')" allowClear></a-input>
						</a-form-model-item>
					</template>
				</template>
			</a-form-model>

			<div class="footer">
				<a-button @click="goLogin">{{ $t("base.btn.back_login") }}</a-button>
				<a-button v-if="basicSetInfo.fywIsSkip == 1" @click="forgetPass">{{ $t("base.btn.pass") }}</a-button>
				<a-button type="primary" @click="forgetOk">{{ $t("base.btn.sure") }}</a-button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { commonAPI } from "@/apis";
import { commonMethods } from "../mixins/common";

export default {
	name: "Forgotten",
	mixins: [commonMethods],
	data() {
		return {
			form: { sjh: "", questionVos: [] },
			rules: {
				sjh: [
					{ required: true, message: this.$t("base.mobile.placeholder") },
					{ pattern: /^1[3456789]\d{9}$/, message: this.$t("base.mobile.error_tip") },
				],
			},
			basicSetInfo: {},
			before_login: {},
		};
	},
	computed: {
		...mapGetters("auth", ["user"]),
	},
	beforeRouteEnter(to, form, next) {
		next((vm) => {
			// 判断是否可进入该路由
			let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
			if (!before_login || !before_login.userInfoConfim) {
				vm.$router.replace({ path: form.path });
			} else {
				vm.before_login = { ...before_login };
			}
		});
	},
	created() {
		// 获取登录配置
		let basicSetInfo = sessionStorage.getItem("BASIC_SET_INFO");
		this.basicSetInfo = basicSetInfo ? JSON.parse(basicSetInfo) : {};

		this.getSelfInfo();
	},
	methods: {
		// 获取自己的密保问题
		async getSelfInfo() {
			const { code, data } = await commonAPI.getAction(`/users/getPwdQuestionByUser/${this.user.username}`);
			if (code == 0) {
				let arr = data || [];
				arr.forEach((el) => {
					this.form.questionVos.push({ name: el.question, question: el.id, answer: "" });
				});
			}
		},
		// 跳过
		async forgetPass() {
			let params = { status: "2", userName: this.user.username };
			const { code, message } = await commonAPI.postAction("/users/fyw/confirm", params);
			if (code == 101) {
				this.before_login.userInfoConfim = false;
				sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
				this.jumpComputed();
			} else {
				this.$message.error(message);
			}
		},
		forgetOk() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					let form = this.form;
					let params = { status: "1", userName: this.user.username, mobile: form.sjh, questionVos: [] };
					if (form.questionVos.length) {
						form.questionVos.forEach((el) => {
							params.questionVos.push({ question: el.question, answer: el.answer });
						});
					}
					(async () => {
						const { code, message } = await commonAPI.postAction("/users/fyw/confirm", params);
						if (code == 0) {
							this.$message.success(message);
							this.before_login.userInfoConfim = false;
							sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
							this.jumpComputed();
						} else {
							this.$message.error(message);
						}
					})();
				} else {
					return false;
				}
			});
		},
	},
};
</script>

<style lang="less" scoped>
.perfect_info::v-deep {
	width: 100%;
	height: 100%;
	padding-top: 35px;
	.container {
		max-width: 800px;
		width: 80%;
		margin: 0 auto;
		background-color: #fff;
		padding: 30px 0;
		border-radius: 20px;
		.title {
			font-size: 22px;
			text-align: center;
			margin-bottom: 20px;
		}
	}

	.ant-input[disabled] {
		color: rgba(0, 0, 0, 0.65);
	}

	.footer {
		text-align: center;
		margin-top: 10px;
		.ant-btn + .ant-btn {
			margin-left: 40px;
		}
	}
}
</style>
